"use client";

import { Container } from "react-bootstrap";
import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/autoplay";

import "./ImplementationSection.scss";
import ProcessSliderSection from "@/components/shared/ProcessSliderSection/ProcessSliderSection";

const ImplementationSection = ({ implementation }) => {
  if (!implementation) return null;

  return (
    <ProcessSliderSection
      title={implementation.title}
      description={implementation.description}
      items={implementation.features}
      sectionClass="implementation-process-section"
       background="bg-light-green"
    />
  );
};

export default ImplementationSection;
